export enum ResourceType {
  OrganizationAudit = 'organization_audit',
  OrganizationAuthSettings = 'organization_auth_settings',
  OrganizationBillingSettings = 'organization_billing_settings',
  OrganizationDefaultLicensingPolicy = 'organization_default_licensing_policy',
  OrganizationDefaultQualityPolicy = 'organization_default_quality_policy',
  OrganizationDefaultSecurityPolicy = 'organization_default_security_policy',
  OrganizationDefaultSBOMPolicy = 'organization_default_sbom_policy',
  OrganizationGeneralSettings = 'organization_general_settings',
  OrganizationIntegrationSettings = 'organization_integration_settings',
  OrganizationLanguageSettings = 'organization_language_settings',
  OrganizationPortalSettings = 'organization_portal_settings',
  OrganizationPortalReports = 'organization_portal_reports',
  OrganizationReport = 'organization_report',

  ProjectAny = 'project_any',
  Project = 'project',

  ProjectLicensingIssueAny = 'project_licensing_issue_any',
  ProjectQualityIssueAny = 'project_quality_issue_any',
  ProjectSecurityIssueAny = 'project_security_issue_any',
  ProjectLicensingIssue = 'project_licensing_issue',
  ProjectQualityIssue = 'project_quality_issue',
  ProjectSecurityIssue = 'project_security_issue',

  ProjectLicensingPolicyAny = 'project_licensing_policy_any',
  ProjectQualityPolicyAny = 'project_quality_policy_any',
  ProjectSecurityPolicyAny = 'project_security_policy_any',
  ProjectLicensingPolicy = 'project_licensing_policy',
  ProjectQualityPolicy = 'project_quality_policy',
  ProjectSecurityPolicy = 'project_security_policy',
  ProjectSBOMPolicyAny = 'project_sbom_policy_any',
  ProjectSBOMPolicy = 'project_sbom_policy',

  ProjectLicensingReportPublicLink = 'project_licensing_report_public_link',
  ProjectLicensingReportPublicLinkAny = 'project_licensing_report_public_link_any',

  ReleaseGroupAny = 'release_group_any',
  ReleaseGroup = 'release_group',
  ReleaseGroupLicensingIssueAny = 'release_group_licensing_issue_any',
  ReleaseGroupQualityIssueAny = 'release_group_quality_issue_any',
  ReleaseGroupSecurityIssueAny = 'release_group_security_issue_any',
  ReleaseGroupLicensingIssue = 'release_group_licensing_issue',
  ReleaseGroupQualityIssue = 'release_group_quality_issue',
  ReleaseGroupSecurityIssue = 'release_group_security_issue',

  ReleaseGroupLicensingPolicy = 'release_group_licensing_policy',
  ReleaseGroupLicensingPolicyAny = 'release_group_licensing_policy_any',
  ReleaseGroupQualityPolicy = 'release_group_quality_policy',
  ReleaseGroupQualityPolicyAny = 'release_group_quality_policy_any',
  ReleaseGroupSecurityPolicy = 'release_group_security_policy',
  ReleaseGroupSecurityPolicyAny = 'release_group_security_policy_any',

  Role = 'role',

  TeamAny = 'team_any',
  Team = 'team',
  TeamProject = 'team_project',
  TeamProjectAny = 'team_project_any',
  TeamReleaseGroupAny = 'team_release_group_any',
  TeamReleaseGroup = 'team_release_group',
  TeamUserAny = 'team_user_any',
  TeamUser = 'team_user',
  TeamReport = 'team_report',

  LicensingPolicyAny = 'licensing_policy_any',
  LicensingPolicy = 'licensing_policy',
  SecurityPolicyAny = 'security_policy_any',
  SecurityPolicy = 'security_policy',
  QualityPolicyAny = 'quality_policy_any',
  QualityPolicy = 'quality_policy',
  SBOMPolicyAny = 'sbom_policy_any',
  SBOMPolicy = 'sbom_policy',

  User = 'user',
  UserAny = 'user_any',

  Label = 'label',

  ProjectLabel = 'project_label',

  IssueFilterLicensing = 'issue_filter_licensing',
  IssueFilterQuality = 'issue_filter_quality',
  IssueFilterSecurity = 'issue_filter_security',

  ProjectIssueFilterLicensing = 'project_issue_filter_licensing',
  ProjectIssueFilterQuality = 'project_issue_filter_quality',
  ProjectIssueFilterSecurity = 'project_issue_filter_security',

  ProjectIssueFilterLicensingAny = 'project_issue_filter_licensing_any',
  ProjectIssueFilterQualityAny = 'project_issue_filter_quality_any',
  ProjectIssueFilterSecurityAny = 'project_issue_filter_security_any',

  PackageLabel = 'package_label',
}

export enum Action {
  Add = 'add',
  Comment = 'comment',
  Create = 'create',
  Delete = 'delete',
  Edit = 'edit',
  Invite = 'invite',
  MakePublic = 'make_public',
  Manage = 'manage',
  Remove = 'remove',
  Resolve = 'resolve',
  Export = 'export',
  Set = 'set',
  SetLocal = 'set_local',
  View = 'view',
}

export type Permission = {
  resourceType: ResourceType;
  action: Action;
  projectId?: string | null;
  releaseGroupId?: number | null;
  teamId?: number | null;
}
